export const MAX_FILE_SIZE_MB = 100;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_NOTES_LENGTH = 1000;

export const ACCEPTED_FILE_TYPES = [
  '.zip',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.svg',
  '.pdf',
  '.doc',
  '.docx',
  '.otf',
  '.rtf',
  '.txt',
  '.ttf',
  '.ppt',
  '.pptx',
  '.csv',
  '.xls',
  '.xlsx',
];
